<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <DormerMaterialRadioFormPart @change="onChange" @result="onResult" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import DormerMaterialRadioFormPart from 'chimera/dormer/components/form/parts/dormerMaterial/DormerMaterialRadioFormPart'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep.vue'
import NextStep from '~/pages/offertes-aanvragen/gewenste-breedte-dakkapel'

export default {
  name: 'DormerMaterialFormStep',

  components: {
    DormerMaterialRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
